import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SwPartNumberService } from '../services/sw-part-number.service';

export const swPartNumberInterceptor: HttpInterceptorFn = (req, next) => {
  const swPartNumberService = inject(SwPartNumberService);
  return next(setSwPartNumberHeader(req, swPartNumberService.getSwPartNumberId()));
};

function setSwPartNumberHeader(
  req: import('@angular/common/http').HttpRequest<unknown>,
  swPartNumberId: string | null
): import('@angular/common/http').HttpRequest<unknown> {
  if (swPartNumberId) {
    return req.clone({
      setHeaders: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Sw-Part-Number-Id': swPartNumberId,
      },
    });
  }
  return req;
}
